document.addEventListener('DOMContentLoaded', () => {
  const detailsMenus = document.querySelectorAll('.mega-menu');

  detailsMenus.forEach(details => {
    const summary = details.querySelector('summary');

    // Prevent default click behavior to avoid toggle
    summary.addEventListener('click', e => {
      e.preventDefault();
    });

    // Open on mouse enter
    details.addEventListener('mouseenter', () => {
      details.setAttribute('open', true);
    });

    let closeTimeout;

    details.addEventListener('mouseenter', () => {
      clearTimeout(closeTimeout);
      details.setAttribute('open', true);
    });
    
    details.addEventListener('mouseleave', () => {
      closeTimeout = setTimeout(() => {
        details.removeAttribute('open');
      }, 50);
    });
    
  });
});

document.addEventListener("DOMContentLoaded", function () {
  document.querySelectorAll("summary.header__menu-item").forEach((summary) => {
    summary.addEventListener("click", function (event) {
      // Prevent default toggle behavior
      event.preventDefault();

      const link = summary.getAttribute("data-href");
      if (link) {
        window.location.href = link;
      }
    });
  });
});
